import { environment } from '@env/environment';

/**
 * Returns true if the URL is a safe external URL backed by a trusted origin.
 * - Scheme MUST be `https:` — all other schemes (http, javascript, data, file, vbscript, blob, …) are rejected
 * - Origin must match one entry in environment.allowedStorageOrigins exactly (via URL.origin)
 * - Returns false for null, undefined, empty string, relative paths, or malformed URLs
 */
export function isAllowedStorageUrl(url: string | null | undefined): boolean {
  if (!url || typeof url !== 'string') return false;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }

  if (parsed.protocol.toLowerCase() !== 'https:') return false;

  const allowed = environment.allowedStorageOrigins ?? [];
  return allowed.some((origin) => {
    try {
      return new URL(origin).origin === parsed.origin;
    } catch {
      return false;
    }
  });
}
